var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        title: "管理清关行",
        width: "1200px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            { staticClass: "opt" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增行")]
              ),
            ],
            1
          ),
          _c("BaseTable", {
            attrs: {
              height: 500,
              tableData: _vm.tableData,
              isPager: false,
              loading: false,
            },
            scopedSlots: _vm._u([
              {
                key: "opt",
                fn: function (row) {
                  return [
                    row.scope.isEdit
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.save(row.scope)
                                },
                              },
                            },
                            [_vm._v("确定")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.getList()
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                        ]
                      : [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  row.scope.isEdit = true
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(row.scope)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ],
                  ]
                },
              },
              {
                key: "code",
                fn: function (row) {
                  return [
                    !row.scope.id && row.scope.isEdit
                      ? _c("el-input", {
                          attrs: { placeholder: "请输入代码" },
                          model: {
                            value: row.scope.code,
                            callback: function ($$v) {
                              _vm.$set(row.scope, "code", $$v)
                            },
                            expression: "row.scope.code",
                          },
                        })
                      : _c("span", [
                          _vm._v(" " + _vm._s(row.scope.code) + " "),
                        ]),
                  ]
                },
              },
              {
                key: "receiver",
                fn: function (row) {
                  return [
                    row.scope.isEdit
                      ? _c("el-input", {
                          attrs: { placeholder: "请输入收件人" },
                          model: {
                            value: row.scope.receiver,
                            callback: function ($$v) {
                              _vm.$set(row.scope, "receiver", $$v)
                            },
                            expression: "row.scope.receiver",
                          },
                        })
                      : _c("span", [
                          _vm._v(" " + _vm._s(row.scope.receiver) + " "),
                        ]),
                  ]
                },
              },
              {
                key: "cc",
                fn: function (row) {
                  return [
                    row.scope.isEdit
                      ? _c("el-input", {
                          attrs: { placeholder: "请输入抄送" },
                          model: {
                            value: row.scope.cc,
                            callback: function ($$v) {
                              _vm.$set(row.scope, "cc", $$v)
                            },
                            expression: "row.scope.cc",
                          },
                        })
                      : _c("span", [_vm._v(" " + _vm._s(row.scope.cc) + " ")]),
                  ]
                },
              },
              {
                key: "replyTo",
                fn: function (row) {
                  return [
                    row.scope.isEdit
                      ? _c("el-input", {
                          attrs: { placeholder: "请输入接收回复邮箱" },
                          model: {
                            value: row.scope.replyTo,
                            callback: function ($$v) {
                              _vm.$set(row.scope, "replyTo", $$v)
                            },
                            expression: "row.scope.replyTo",
                          },
                        })
                      : _c("span", [
                          _vm._v(" " + _vm._s(row.scope.replyTo) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }